export default __webpack_public_path__ + "static/media/icon_sword.619c9c2d.png";